// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"658":"683603a2","827":"94b3aac1","958":"b9430ca2"}[chunkId] + ".chunk.js";
};